const words = ["Open a case", "Investigate", "Decide", "Follow up", "Advisory board", "Action plan"];

function MarqueeContent() {
  return (
    <>
      {words.map((w) => (
        <span key={w} className="flex items-center shrink-0">
          <span className="font-serif-display italic font-light text-6xl md:text-8xl text-stroke-white px-6 md:px-10">
            {w}
          </span>
          <span className="w-2 h-2 rounded-full bg-[#C9B896]/70 shrink-0" />
        </span>
      ))}
    </>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/[0.07] bg-[#0E0D0B] py-10 md:py-14 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        <MarqueeContent />
        <MarqueeContent />
      </div>
    </section>
  );
}
